// extracted by mini-css-extract-plugin
export var active = "_1s-b";
export var activeIndicator = "_1s-6";
export var animate = "_1s-a";
export var disabled = "_1s-c";
export var flat = "_1s-1";
export var fullWidth = "_1s-3";
export var lg = "_1s-9";
export var md = "_1s-8";
export var redoButtonTabGroup = "_1s-0";
export var sm = "_1s-7";
export var tabButton = "_1s-4";
export var tabButtonsContainer = "_1s-2";
export var xs = "_1s-5";